import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { fetchAuthSession } from 'aws-amplify/auth'
import paths from 'constants/paths'
import { v4 as uuidV4 } from 'uuid'

export const apiTags = {
  BANNER_ACTIVE: 'BannerActive',
  BANNER_LIST: 'BannerList',
  FEATURE_TOGGLE: 'FeatureToggle',
  RELEASE_NOTE: 'ReleaseNote',
  USER_LIST: 'UserList',
  USER_ROLES_LIST: 'UserRolesList',
}

const baseApi = createApi({
  reducerPath: 'api',

  baseQuery: fetchBaseQuery({
    baseUrl: process.env.BACK_END_URL,

    prepareHeaders: async headers => {
      // Add Request-level tracing headers
      headers.set('cargomate-request-id', uuidV4())
      headers.set('source', 'web-dashboard')

      // Attach Cognito JWT unless auth is explicitly disabled
      if (process.env.AUTHORIZATION !== 'false') {
        try {
          const { tokens } = await fetchAuthSession()
          headers.set('Authorization', tokens.idToken.toString())
        } catch {
          // Session expired or no active session — save the current path and redirect to login.
          const currentPath = window.location.pathname
          if (currentPath !== paths.overview) {
            sessionStorage.setItem('go-to-path-on-login', currentPath)
          }
          window.location.href = paths.login
        }
      }

      return headers
    },
  }),

  // Register shared cache tag types
  tagTypes: [
    apiTags.FEATURE_TOGGLE,
    apiTags.USER_LIST,
    apiTags.USER_ROLES_LIST,
    apiTags.RELEASE_NOTE,
    apiTags.BANNER_LIST,
    apiTags.BANNER_ACTIVE,
  ],

  endpoints: () => ({}),
})

export default baseApi
